import useResponsiveLayout from '@utils/hooks/useResponsiveLayout';
import RouterMobile from '@router/mobile/RouterMobile';
import RouterDesktop from '@router/desktop/RouterDesktop';

const Router = (): JSX.Element => {
    const { isDesktop } = useResponsiveLayout();
    return isDesktop ? <RouterDesktop /> : <RouterMobile />;
};

export default Router;
